import { getPanelScale } from '../../../utils/panel-zoom/get-panel-scale';

const CSS_VAR_CARD_RENDERED_WIDTH = '--card-rendered-width';
const WORKSPACE_SELECTOR = '[data-testid="Workspace"]';

type SetCardRenderedWidthParams = {
  containerRef: React.RefObject<HTMLElement>;
  isPanelZoom: boolean;
  containerWidth: number;
  containerHeight: number;
  logicalWidth: number;
  logicalHeight: number;
  /** Measured width of the canvas wrapper element on screen. */
  measuredWidth: number;
};

/**
 * Sets `--card-rendered-width` on the workspace panel so CSS can size
 * the toolbar host container dynamically:
 * `calc(50% - var(--card-rendered-width) / 2 - padding)`.
 */
export const setCardRenderedWidth = ({
  containerRef,
  isPanelZoom,
  containerWidth,
  containerHeight,
  logicalWidth,
  logicalHeight,
  measuredWidth,
}: SetCardRenderedWidthParams): void => {
  let renderedCardWidth: number;
  if (isPanelZoom) {
    const { halfWidth, panelScale } = getPanelScale({ containerWidth, containerHeight, logicalWidth, logicalHeight });
    renderedCardWidth = Math.round(halfWidth * panelScale);
  } else {
    renderedCardWidth = measuredWidth;
  }

  // A hidden workspace (e.g. preview mode) measures 0; keep the last real width.
  if (renderedCardWidth <= 0) {
    return;
  }

  const workspacePanel = containerRef.current?.closest<HTMLElement>(WORKSPACE_SELECTOR);
  if (workspacePanel) {
    workspacePanel.style.setProperty(CSS_VAR_CARD_RENDERED_WIDTH, `${renderedCardWidth}px`);
  }
};
